module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-chart-container",
    class: _vm.containerClass
  }, [_c('ReportFilterBadge', {
    attrs: {
      "metadata": _vm.data.metadata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-chart-canvas",
    style: (_vm.canvasStyle)
  }, [_c(_vm.chartComponent, {
    tag: "component",
    attrs: {
      "data": _vm.data
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8b9bb86","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ReportChartContainer.vue
// module id = 762
// module chunks = 1